export default "__VITE_ASSET__S3H8AnBR__"